module.exports = __webpack_public_path__ + "img/project-2.53757a91.jpg";